<template lang="html">
  <div class="main">
    <div v-if="data.id">
      <div class="title">
        {{message.Al183}}
      </div>
      <div class="cell">
        <span v-if="data.listType === 'all'">
          {{message.Al111}}：{{ data.durationTime }}
        </span>
        <span v-if="data.listType !== 'all'">
          {{message.Al110}}：{{ data.remainTime }}
        </span>
        <span>
          <!-- <span v-if="data.listType !== 'all'">
            {{message.Al109}}：{{ data.averageBitrate }}
          </span> -->
          <span v-if="data.listType !== 'all'">
            {{message.Al209}}：{{ data.bitrate }}&nbsp;&nbsp;({{ data.bps }})
          </span>
          <span v-if="data.listType === 'all'">
            {{message.Al109}}：{{ data.bitrate }}&nbsp;&nbsp;({{ data.bps }})
          </span>
        </span>
      </div>
      <div class="cll charts">
        <div id="bitrateChart">
        </div>
      </div>
      <div class="cell more">
        <span>{{message.Al133}}</span>
        <span>
          {{message.Al182}}:  {{data.title}}
        </span>
        <span>
          {{message.Sl161}}:  {{data.project}}
        </span>
        <span>
          {{message.Al181}}:  {{ data.size }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import walden from '@/style/walden.json'
export default {
  watch: {
    'data.id': function (val) {
      this.$nextTick(() => {
        if (val) {
          this.getDataInit(val)
        }
      })
    },
    'data.type': function (val, oldVal) {
      if ((oldVal || oldVal === 0) && val) {
        if (val === 1) {
          this.keepAlive()
        }
      }
    }
  },
  data () {
    return {
      message: {
        Al100: this.$lang.ui.app.l100,
        Al101: this.$lang.ui.app.l101,
        Al102: this.$lang.ui.app.l102,
        Al103: this.$lang.ui.app.l103,
        Al104: this.$lang.ui.app.l104,
        Al105: this.$lang.ui.app.l105,
        Al106: this.$lang.ui.app.l106,
        Al107: this.$lang.ui.app.l107,
        Al108: this.$lang.ui.app.l108,
        Al109: this.$lang.ui.app.l109,
        Al110: this.$lang.ui.app.l110,
        Al111: this.$lang.ui.app.l111,
        Al133: this.$lang.ui.app.l133,
        Al150: this.$lang.ui.app.l150,
        Al151: this.$lang.ui.app.l151,
        Al181: this.$lang.ui.app.l181,
        Al182: this.$lang.ui.app.l182,
        Al183: this.$lang.ui.app.l183,
        Al209: this.$lang.ui.app.l209,
        Sl161: this.$lang.ui.system.l161
      },
      records: [],
      keepFunc: null,
      time: 5000
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          id: null,
          project: String,
          title: String,
          durationTime: String,
          type: Number,
          taskType: String,
          bitrate: String,
          remainTime: String,
          size: String,
          listType: String,
          bps: String,
        }
      }
    }
  },
  mounted () {
    echarts.registerTheme('walden', walden)
  },
  methods: {
    chart () {
      let main = document.getElementById('bitrateChart')
      let existInstance = echarts.getInstanceByDom(main)
      if (existInstance !== undefined) {
        return existInstance
      }
      let myChart = echarts.init(main, 'walden')
      return myChart
    },
    getDataInit (id) {
      this.chart().showLoading()
      this.records = []
      var e = {
        taskType: this.data.taskType,
        taskId: this.data.id,
        start: this.records.length
      }
      this.$app.getBitList(e, response => {
        this.records = []
        this.chart().hideLoading()
        if (response.bitrate) {
          for (var i = 0; i < response.bitrate.length; i++) {
            this.records.push(response.bitrate[i])
          }
        } else {
          this.records.push(0)
        }
        this.drawChart()
        this.keepAlive()
      })
    },
    keepAlive () {
      if (this.data && this.data.type === 1) {
        clearInterval(this.keepFunc)
        var that = this
        this.keepFunc = setInterval(() => {
          this.getData()
        }, that.time)
      } else {
        clearInterval(this.keepFunc)
      }
    },
    getData () {
      if (this.data && this.data.type === 1) {
        var e = {
          taskType: this.data.taskType,
          taskId: this.data.id,
          start: this.records.length
        }
        this.$app.getBitList(e, response => {
          if (!response.bitrate) {
            return
          }
          for (var i = 0; i < response.bitrate.length; i++) {
            this.records.push(response.bitrate[i])
          }
          this.chart().setOption({
            xAxis: {
              data: this.records.map((item, index) => {
                var val = index * 2
                return val
              })
            },
            series: [{
              name: '',
              data: this.records.map((item, index) => {
                var val = item
                return val
              }),
              markLine: {
                data: [{
                  yAxis: this.data.bitrate
                }]
              }
            }]
          })
        })
      } else {
        clearInterval(this.keepFunc)
      }
    },
    drawChart () {
      var myChart = this.chart()
      myChart.setOption({
        backgroundColor: '#fff',
        tooltip: {
          trigger: 'axis',
          formatter: (val) => {
            var x = this._global.bandwidthSwitch(val[0].data)
            return x
          }
        },
        grid: {
          'borderWidth': 0,
          'top': 15,
          'left': 80,
          'right': 10,
          'bottom': 60
        },
        xAxis: [{
          data: this.records.map((item, index) => {
            var val = index * 2 + 's'
            return val
          })
        }],
        yAxis: {
          splitLine: {
            show: false
          },
          'axisLabel': {
            formatter: (value, index) => {
              var x = this._global.bandwidthSwitch(value)
              return x
            }
          }
        },
        dataZoom: [{
          startValue: '' + this.records.length * 2 - 100 + '' + 's'
          // start: 98,
          // end: 100
        },
        {
          type: 'inside'
        }],
        series: {
          name: '',
          type: 'line',
          data: this.records.map((item, index) => {
            var val = item
            return val
          }),
          markLine: {
            silent: true,
            data: [{
              yAxis: this.data.bitrate
            }]
          }
        }
      })
    }
  },
  beforeDestroy () {
    clearInterval(this.keepFunc)
  }
}
</script>

<style lang="css" scoped>
.main {
  position: relative;
  margin: 0;
  display: block;
  padding: 0 10px;
  width: 100%;
  height: 100%;
  border: 1px solid #ebebeb;
}
.title {
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  font-weight: 600;
}
.cell {
  width: 100%;
}
.cell span {
  display: inline-block;
  width: 100%;
  font-size: 14px;
  padding: 4px 0;
}
.charts {
  height: 260px;
  margin: 15px 0;
}
.cell.more span{
  padding: 6px 0;
  font-weight: 500;
  font-size: 14px;
}
#bitrateChart {
  z-index: 3;
  width: 100%;
  height: 100%;
}
</style>
